/** Idle inactivity limit before automatic sign-out (finance app policy). */
export const IDLE_SESSION_TIMEOUT_MS = 60 * 60 * 1000;

/** Show warning this long before idle sign-out. */
export const IDLE_SESSION_WARNING_MS = 5 * 60 * 1000;

export const IDLE_SESSION_TIMEOUT_MINUTES = 60;
